import {useMemo} from 'react';

import {startOfMonth} from '../helpers';

export default function useMonthSelector(selectedDate, onChangeMonth) {
  const start = startOfMonth(new Date(2025, 0, 1));
  const end = startOfMonth(new Date());

  const visibleMonths = useMemo(() => {
    const months = [];
    const cursor = new Date(start);

    while (cursor <= end) {
      months.push(new Date(cursor));
      cursor.setMonth(cursor.getMonth() + 1);
    }

    return months;
  }, [start, end]);

  const selectedIndex = useMemo(() => visibleMonths.findIndex(d => d.getMonth() === selectedDate.getMonth() && d.getFullYear() === selectedDate.getFullYear()), [visibleMonths, selectedDate]);

  const handleSelect = index => {
    onChangeMonth(visibleMonths[index]);
  };

  return {
    visibleMonths,
    selectedIndex,
    handleSelect
  };
}
